import styled from 'styled-components';

export const EmptyContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
`;
